import React from "react";
import BeatLoader from "react-spinners/BeatLoader";

const Validating = (props) => {
  return (
    <div className="container-fluid">
      {/* <h1>Validating</h1> */}
      <div className="row rows-qr mx-auto d-block align-items-center">
        <p>We are validating your parking. Please wait.</p>
      </div>
      <div className="row row-qr mx-auto d-block align-items-center">
        <BeatLoader color={"#ffda00"} />
      </div>
    </div>
  );
};

export default Validating;
